module.exports = __webpack_public_path__ + "static/media/am.c86a9e16.svg";